<header [ngClass]="className" (click)="toggle.emit()" role="group">
  @if (hideWarningIcon === false) {
    <i class="far fa-exclamation-triangle fa-fw errors__icon"></i>
  }

  <div class="errors__info">
    <div class="errors__title">
      <ng-template
        [ngTemplateOutlet]="title ?? defaultTitle"
        [ngTemplateOutletContext]="{ errorCount }"
      ></ng-template>

      <ng-template #defaultTitle>
        <span>
          {{ 'common.errors.title.' + (errorCount === 1 ? 'single' : 'multiple') | portalTranslate }}
        </span>

        @if (errorCount > 1) {
          <span class="badge text-bg-danger ms-1">{{ errorCount }}</span>
        }
      </ng-template>
    </div>

    @if (summary != null) {
      <div class="errors__summary" [ngTemplateOutlet]="summary"></div>
    }
  </div>

  <div class="errors__actions">
    <portal-icon-button
      [portalTippy]="'common.errors.export.info' | translate"
      [preventAndStop]="true"
      (onClick)="downloadErrors()"
      iconClass="far fa-download"
    ></portal-icon-button>

    <portal-copy-to-clipboard [text]="rawErrors"></portal-copy-to-clipboard>

    @if (dismissible) {
      <portal-icon-button
        [portalTippy]="'common.errors.hide.info' | portalTranslate"
        [preventAndStop]="true"
        (onClick)="hide.emit()"
        iconClass="far fa-times"
      ></portal-icon-button>
    }
  </div>

  @if (hideCollapse === false) {
    <portal-icon-button iconClass="far fa-angle-down"></portal-icon-button>
  }
</header>
